import { Fragment, useEffect, useState } from "react";
import { Dialog as DialogComponent, Transition } from "@headlessui/react";

export default function Dialog({ open, onClose, children, width, className }) {
  const [dialogWidth, setDialogWidth] = useState(
    typeof window !== "undefined" && window.innerWidth <= 768
      ? "100%"
      : width ?? "640px"
  );

  useEffect(() => {
    const handleResize = () => {
      setDialogWidth(window.innerWidth <= 768 ? "100%" : width ?? "640px");
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  return (
    <Transition show={open} as={Fragment}>
      <DialogComponent
        as="div"
        className="relative z-[99999]"
        onClose={onClose}
      >
        {/* Backdrop Transition */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500/55  backdrop-blur-sm" />
        </Transition.Child>

        {/* Panel Transition */}
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center md:items-center md:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 md:translate-y-0 md:scale-95"
              enterTo="opacity-100 translate-y-0 md:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 md:scale-100"
              leaveTo="opacity-0 translate-y-4 md:translate-y-0 md:scale-95"
            >
              <DialogComponent.Panel
                className={`relative transform overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all md:my-8 w-full md:max-w-lg ring-1 ring-[#000] md:m-[1rem] max-md:m-auto ${className}`}
                style={{
                  maxWidth: dialogWidth,
                }}
              >
                <div className="p-6 w-full">{children}</div>
              </DialogComponent.Panel>
            </Transition.Child>
          </div>
        </div>
      </DialogComponent>
    </Transition>
  );
}
